import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-admin-company-form',
  templateUrl: './admin-company-form.component.html',
  styleUrls: ['./admin-company-form.component.scss']
})

export class AdminCompanyFormComponent implements AfterViewInit {

  @ViewChild("table", { static: false }) table: TableComponent;
  public uuid;
  public company: any = {};
  public showEditForm = false;
  public addExistingForm = false;
  public availableUser :any = [];
  public existing_user_id: any = null;
  public savingCompany = false;

  constructor(private route: ActivatedRoute, private http: HttpService, private cdr: ChangeDetectorRef, private router: Router) { 

    if (this.router.url.indexOf("lo/admin/company/form") > -1) {
      this.showEditForm = true;
    }

    const uuid: Observable<string> = this.route.params.pipe(map(p => p['company_uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.getCompany(val);
        this.uuid = val;
        this.getAvailableUser();
      }
    })
  }

  ngAfterViewInit(): void {
    if (this.uuid) {
      this.init(this.uuid)
    }
  }

  async getCompany(uuid) {
    this.company = await this.http.post("/admin/company/get/detail", {uuid: uuid});
  }

  async init(uuid) {

      const user_permissions = this.http.getSelecetdCompanyDetail();

      const setting = 
        { post: {url: "/admin/company/user/get", data: {uuid: uuid}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Admin', type: 'string', key: 'name'}, 
            {label: 'Username', type: 'string', key: 'username'}, 
            {label: 'Can View', type: 'yesno', key: 'can_view'}, 
            {label: 'Can Manage', type: 'yesno', key: 'can_manage'}, 
            {label: 'Can Search', type: 'yesno', key: 'can_search'}, 
            {label: 'Can Report', type: 'yesno', key: 'can_report'}, 
            {label: 'Can Adjust', type: 'yesno', key: 'can_adjust'}, 
            {label: 'Can Adjust 2', type: 'yesno', key: 'can_adjust2'}, 
            {label: 'App Setting', type: 'yesno', key: 'adjust_app'}, 
            {label: 'Can Export', type: 'yesno', key: 'can_export'}, 
            {label: 'Can Show Number', type: 'yesno', key: 'show_number'}, 
            {label: 'Game Integration', type: 'yesno', key: 'game_integration'}, 
            {label: 'Summary Report', type: 'yesno', key: 'summary_report'}, 
            {label: 'Edit Summary Report', type: 'yesno', key: 'edit_summary_report'}, 
            {label: 'Daily Report', type: 'yesno', key: 'daily_report'}, 
            {label: 'Edit Daily Report', type: 'yesno', key: 'edit_daily_report'}, 
            {label: 'Expenses', type: 'yesno', key: 'expenses'}, 
            {label: 'Edit Expenses', type: 'yesno', key: 'edit_expenses'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'Create On', type: 'date', key: 'timestamp'}, 
            {label: 'Permission', type: 'link', key: 'ac_uuid', 'link': '/lo/admin/user/permission' , hide: true, hide_super_admin: true},
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/admin/user/form/' + uuid , hide: true, hide_super_admin: true},
            {label: 'Delete', type: 'delete', key: 'id', table: 'admin_user_company', title: 'name', hide: true, hide_super_admin: true},
          ]}

          let permissions = ['can_view', 'can_manage',  'can_search', 'can_report', 'can_adjust', 'adjust_app', 'can_export', 'show_number', 'game_integration', 'summary_report', 'daily_report', 'expenses', 'edit_summary_report', 'edit_daily_report', 'edit_expenses']

          for(var x = 0; x < permissions.length; x++) {
            let cp:string = permissions[x]
            if(!user_permissions[cp]) {
              let matchIndex = setting.fields.findIndex((v:any) => { return v.key === cp});

              if(matchIndex > -1) {
                setting.fields.splice(matchIndex, 1);
              }
            }
          }

          this.table.init(setting);
        this.cdr.detectChanges();

  }

  async companyUpdate() {
    if (this.savingCompany) return;
    this.savingCompany = true;
    try {
      const s = await this.http.post("/admin/company/update/detail", this.company);
      if (!s?.['status']) return;
      await this.http.setCompany();
      if (!this.uuid && s['uuid']) {
        this.http.navigate(['/lo/admin/company/form', s['uuid']]);
      }
    } finally { this.savingCompany = false; }
  }

  addExistingFormToogle() {
    this.addExistingForm = !this.addExistingForm;
  }

  async getAvailableUser() {
    this.availableUser = await this.http.post("/admin/user/get/available", {uuid: this.uuid});
  }

  async addExistingUser() {
    
    if (!this.existing_user_id) {
      return;
    }

    const data = {user_id : this.existing_user_id, com_uuid : this.uuid};
    const result = await this.http.post("/admin/company/add/user", data);
    if (!result?.['status']) return;
    await this.http.setCompany();

    await this.getAvailableUser();
    this.init(this.uuid);
    this.addExistingForm = false;
  }
}
